"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "group.selectionGroups";
  var componentName = "selectGroups";

  var bindings = {
    selectedIds: "="
  };

  var templateUrl = "app/pages/groups/selectionGroups/selectionGroups.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $rootScope, $timeout, GroupsService, AgGridService, CustomersService) {
      _classCallCheck(this, Controller);

      console.log(moduleName + "/" + componentName);

      this.$scope = $scope;
      this.$rootScope = $rootScope;
      this.$timeout = $timeout;
      this.GroupsService = GroupsService;
      this.AgGridService = AgGridService;
      this.CustomersService = CustomersService;

      this.columnDefs = [this.AgGridService.text("name", "Nom du groupe"), AgGridService.button("btDelete", "Retirer", this.delete, this, {
        width: 90
      })];
    }

    _createClass(Controller, [{
      key: "envChanged",
      value: function envChanged(evt) {
        var index = this.selectedIds.indexOf(this.selectedGroup.value);

        if (index == -1) {
          this.selectedIds.push(this.selectedGroup.value);
          this.updateTable();
        }
      }
    }, {
      key: "delete",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(row, ctx) {
          var deleteElement, index;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return swal({
                    title: "Voulez-vous retirer le groupe " + row.name + " ?",

                    icon: "warning",
                    dangerMode: true,

                    buttons: ["Annuler", "Valider"]
                  });

                case 2:
                  deleteElement = _context.sent;


                  if (deleteElement) {
                    index = ctx.selectedIds.indexOf(row.value);


                    if (index > -1) {
                      ctx.selectedIds.splice(index, 1);
                      ctx.updateTable();
                    }
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function _delete(_x, _x2) {
          return _ref.apply(this, arguments);
        }

        return _delete;
      }()
    }, {
      key: "deleteAll",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ctx) {
          var deleteElement;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return swal({
                    title: "Voulez-vous retirer tous les groupes ?",

                    icon: "warning",
                    dangerMode: true,

                    buttons: ["Annuler", "Valider"]
                  });

                case 2:
                  deleteElement = _context2.sent;


                  if (deleteElement) {
                    ctx.selectedIds = [];
                    ctx.updateTable();
                  }

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function deleteAll(_x3) {
          return _ref2.apply(this, arguments);
        }

        return deleteAll;
      }()
    }, {
      key: "addAll",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ctx) {
          var addElement;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return swal({
                    title: "Voulez-vous ajouter tous les groupes ?",

                    icon: "warning",
                    dangerMode: true,

                    buttons: ["Annuler", "Valider"]
                  });

                case 2:
                  addElement = _context3.sent;


                  if (addElement) {
                    ctx.selectedIds = ctx.groupArray.map(function (group) {
                      return group.value;
                    });
                    ctx.updateTable();
                  }

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function addAll(_x4) {
          return _ref3.apply(this, arguments);
        }

        return addAll;
      }()
    }, {
      key: "updateTable",
      value: function updateTable() {
        var _this = this;

        var promises = [];

        promises.push(this.GroupsService.getSelectArray());

        Promise.all(promises).then(function (values) {
          _this.groupArray = values[0];

          //console.log('this.selectedIds', this.selectedIds.sort())

          if (_this.selectedIds) {
            var selectedGroups = [];

            for (var indexGroup = 0; indexGroup < _this.selectedIds.length;) {
              var groupId = _this.selectedIds[indexGroup];

              var group = _this.groupArray.find(function (el) {
                return el.value === groupId;
              });

              if (group) {
                group.btDelete = {
                  text: '<i class="fa fa-eraser"></i> Retirer',
                  color: "custom"
                };
                selectedGroups.push(group);
                indexGroup++;
              } else {
                console.log("no group for " + groupId);
                _this.selectedIds.splice(indexGroup, 1);
              }
            }

            _this.rawData = selectedGroups;

            _this.$timeout(function () {
              _this.needToBeUpdate = true;
            });
          } else {
            _this.selectedIds = [];
          }
        });
      }
    }, {
      key: "$onInit",
      value: function $onInit() {
        var _this2 = this;

        this.$scope.$watch(function () {
          return _this2.selectedIds;
        }, function () {
          console.log("this.selectedIds", _this2.selectedIds);

          _this2.updateTable();
        });
      }
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();